// TOP LEVEL IMPORTS
import React from 'react';
import { Switch } from 'react-router-dom';
// LAYOUTS
import Layout from './components/common/Layout';
// ROUTE COMPONENTS
import RouteWrapper from 'components/common/RouteWrapper'; // will just render whatever you give it, agnostic to if user is authenticated or not
// ROUTES
import Home from './routes/home';
import Settings from './routes/settings';

// EXPORTED COMPONENT
// ========================================
class AppRoutes extends React.Component {
  render() {
    return (
      <Switch>
        <RouteWrapper
          layout={Layout}
          path="/in-stock/settings"
          component={Settings}
        />
        <RouteWrapper layout={Layout} path="/in-stock" component={Home} />
      </Switch>
    );
  }
}

// EXPORT
// ==============================
export default AppRoutes;
